export default __webpack_public_path__ + "media/images/logo-cybre-light-f388fea4b469fbe978d4babb951c0f76.png";